export enum InvestAccountAction {

    None,
    SignUp,
    Switch,
}
